export enum ComponentType {
    Physician = 'PHYSICIAN',
    Institution = 'INSTITUTION',
    MailingAddress = 'MAILING_ADDRESS'
}
